import * as React from "react";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "./ListItem";
import FeaturePreview from "./FeaurePreview";

export default function InfoPopper(props) {
    const [open, setOpen] = React.useState(false);
    const [displayedFeature, setDisplayedFeature] = React.useState();

    useEffect(() => {
        if (props?.feature) {
            setDisplayedFeature(props.feature);
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [props?.feature]);

    if (!displayedFeature && !open) {
        return null;
    }

    return (
        <Fade in={open} timeout={350} unmountOnExit onExited={() => setDisplayedFeature(undefined)}>
            <Paper
                sx={{
                    position: "fixed",
                    left: "50%",
                    bottom: "30px",
                    transform: "translateX(-50%)",
                    minHeight: "60px",
                    boxShadow: 1,
                    borderRadius: 2,
                    p: 2,
                    minWidth: 375,
                    zIndex: (theme) => theme.zIndex.tooltip,
                }}
            >
                <List disablePadding={true}>
                    <ListItem>
                        <FeaturePreview feature={displayedFeature} />
                    </ListItem>
                </List>
            </Paper>
        </Fade>
    );
}
